<template>
  <div class="body-inner">
    <page-header></page-header>
    <div class="container has-text-centered">    
      <router-view></router-view>
    </div>
    <page-footer></page-footer>    
  </div>
</template>

<script>
import PageHeader from './PageHeader'
import PageFooter from './PageFooter'

export default {
  name: 'app',
  components: {
    PageHeader,
    PageFooter
  }
}
</script>


// WEBPACK FOOTER //
// src/components/App.vue